import React from "../../__compat__/react/main.entry.mjs.mjs";
import { useSeparator } from "../../__compat__/@react-aria/separator/main.entry.mjs.mjs";
import { useSpacing } from "../../api/spacing/useSpacing.mjs.mjs";
import { pickComponentCommonProps } from "../../interfaces/commonProps.mjs.mjs";
import { StyledDivider } from "./Divider.styles.mjs.mjs";
export const Divider = React.forwardRef(function Divider({ as, role, ...restProps }, ref) {
    const { separatorProps } = useSeparator({ elementType: as, ...restProps });
    const commonProps = pickComponentCommonProps(restProps);
    const outerSpacing = useSpacing(restProps);
    return (React.createElement(StyledDivider, { ref: ref, as: as, role: role, ...separatorProps, ...commonProps, outerSpacing: outerSpacing }));
});
//# sourceMappingURL=Divider.mjs.mjs.map